export const PHOTO_UPLOAD_CONFIG = {
  mimeTypes: {
    'image/png': ['.png'],
    'image/jpeg': ['.jpeg', '.jpg'],
  },
  maxSize: 5 * 1024 ** 2,
  multiple: false,
};
